import { createRoute } from '@tanstack/react-router';
import { appLayoutRoute } from '../router/parents';
import { BrandPage } from './brand';
import { CalendarPage } from './calendar';
import { ChannelsPage } from './channels';
import { ContentEditorPage } from './content';
import { CompaniesPage, CompanyDetailPage, ContactDetailPage, ContactsPage, ImportPage, ListsPage, PipelinePage, TasksPage } from './crm';
import { DashboardPage } from './dashboard';
import { EmailPage } from './email';
import { ResultsPage } from './results';
import { ReviewPage } from './review';
import { SequencesPage } from './sequences';
import { BillingPage, GeneralSettingsPage, IntegrationsPage, TeamPage } from './settings';

export const appRoutes = [
  createRoute({ getParentRoute: () => appLayoutRoute, path: '/dashboard', component: DashboardPage }),
  createRoute({ getParentRoute: () => appLayoutRoute, path: '/calendar', component: CalendarPage }),
  createRoute({ getParentRoute: () => appLayoutRoute, path: '/review', component: ReviewPage }),
  createRoute({ getParentRoute: () => appLayoutRoute, path: '/content/$id', component: ContentEditorPage }),
  createRoute({ getParentRoute: () => appLayoutRoute, path: '/brand', component: BrandPage }),
  createRoute({ getParentRoute: () => appLayoutRoute, path: '/channels', component: ChannelsPage }),
  createRoute({ getParentRoute: () => appLayoutRoute, path: '/results', component: ResultsPage }),
  createRoute({ getParentRoute: () => appLayoutRoute, path: '/email', component: EmailPage }),
  createRoute({ getParentRoute: () => appLayoutRoute, path: '/crm', component: ContactsPage }),
  createRoute({ getParentRoute: () => appLayoutRoute, path: '/crm/contacts', component: ContactsPage }),
  createRoute({ getParentRoute: () => appLayoutRoute, path: '/crm/contacts/$contactId', component: ContactDetailPage }),
  createRoute({ getParentRoute: () => appLayoutRoute, path: '/crm/companies', component: CompaniesPage }),
  createRoute({ getParentRoute: () => appLayoutRoute, path: '/crm/companies/$companyId', component: CompanyDetailPage }),
  createRoute({ getParentRoute: () => appLayoutRoute, path: '/crm/pipeline', component: PipelinePage }),
  createRoute({ getParentRoute: () => appLayoutRoute, path: '/crm/tasks', component: TasksPage }),
  createRoute({ getParentRoute: () => appLayoutRoute, path: '/crm/lists', component: ListsPage }),
  createRoute({ getParentRoute: () => appLayoutRoute, path: '/crm/import', component: ImportPage }),
  createRoute({ getParentRoute: () => appLayoutRoute, path: '/sequences', component: SequencesPage }),
  createRoute({ getParentRoute: () => appLayoutRoute, path: '/settings', component: GeneralSettingsPage }),
  createRoute({ getParentRoute: () => appLayoutRoute, path: '/settings/team', component: TeamPage }),
  createRoute({ getParentRoute: () => appLayoutRoute, path: '/settings/billing', component: BillingPage, validateSearch: (s: Record<string, unknown>): { checkout?: string } => ({ checkout: typeof s.checkout === 'string' ? s.checkout : undefined }) }),
  createRoute({ getParentRoute: () => appLayoutRoute, path: '/settings/integrations', component: IntegrationsPage }),
] as const;
